import React from 'react'

import objectsTableStyles from "./ObjectsTable.module.css"

export default function ArrowButton({open}) {
    return(       
        <div className={objectsTableStyles.btn} >            
            {
                open
                ? 
                <svg className={objectsTableStyles.svgdBtn} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.42 94.12">
                    <path d="M172.82,200.65a9.9,9.9,0,0,0,0,14l74.3,74.3a9.9,9.9,0,0,0,14,0l74.3-74.3a9.9,9.9,0,0,0-14-14L254.12,268l-67.3-67.3A10,10,0,0,0,172.82,200.65Z" transform="translate(-169.92 -197.73)"/>
                </svg>
                :
                <svg className={objectsTableStyles.svgdBtn} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.12 168.42">
                    <path d="M210,326.1a9.9,9.9,0,0,0,14,0l74.3-74.3a9.9,9.9,0,0,0,0-14L224,163.5a9.9,9.9,0,0,0-14,14l67.3,67.3L210,312.1A10,10,0,0,0,210,326.1Z" transform="translate(-207.08 -160.58)"/>
                </svg>             
            }
        </div>   
    )
}

// export default function ArrowButton({open}) {
//     return(       
//         <div className={objectsTableStyles.btn} >            
//             {
//                 open
//                 ? 
//                 <svg className={objectsTableStyles.svgdBtn} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455 455">
//                     <path d="M455,227.5C455,101.86,353.14,0,227.5,0S0,101.86,0,227.5,101.86,455,227.5,455,455,353.14,455,227.5Zm-355.59-28,21.18-21.25L227.5,284.79,334.41,178.23l21.18,21.25L227.5,327.15Z"/>
//                     <polygon points="334.41 178.23 227.5 284.79 120.59 178.23 99.41 199.48 227.5 327.15 355.59 199.48 334.41 178.23"/>
//                 </svg>
//                 :
//                 <svg className={objectsTableStyles.svgdBtn} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455 455">
//                     <path d="M227.5,0C101.86,0,0,101.86,0,227.5S101.86,455,227.5,455,455,353.14,455,227.5,353.14,0,227.5,0Zm-28,355.59-21.25-21.18L284.79,227.5,178.23,120.59l21.25-21.18L327.15,227.5Z"/>
//                     <polygon points="178.23 120.59 284.79 227.5 178.23 334.41 199.48 355.59 327.15 227.5 199.48 99.41 178.23 120.59"/>
//                 </svg>             
//             }
//         </div>   
//     )
// }